import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../helpers/reducerRegistry'
import { STATUS_MESS } from '../constants'
import {
  getListTopic,
  getListTopicScroll,
  getMessageInTopic,
  getQuestion,
  getTopicMaxUpdatedDate,
  updateTopic,
} from './thunk'

const initialState = {
  isShowHistoryList: false,
  isLoadingHistoryList: false,
  isLoadingHistoryListMore: false,
  historyList: [],
  topicActive: {
    topicId: null,
    topicTitle: null,
  },
  loadingMessageTopic: false,
  messageTopic: [],
  statusMess: STATUS_MESS.ACTIVE,
  listQuestion: [],
  loadingQuestion: false,
  typing: {
    messageId: null,
    done: true,
  },
  topicMaxUpdatedDate: null,
  topicMaxUpdatedLoading: false,
}

const slice = createSlice({
  name: 'chatbot/fiinAssistant',
  initialState,
  reducers: {
    changeShowHistoryList: (state, action) => {
      state.isShowHistoryList = action.payload
    },
    changeTopicActive: (state, { payload }) => {
      state.topicActive = {
        topicId: payload.topicId,
        topicTitle: payload?.topicTitle || state.topicActive?.topicTitle,
      }
    },
    changStatusMess: (state, action) => {
      state.statusMess = action.payload
    },
    addMessageInTopic: (state, action) => {
      state.messageTopic = [...state.messageTopic, action.payload]
    },
    createNewTopic: (state, action) => {
      state.messageTopic = []
      state.topicActive = { topicId: null, topicTitle: null }
    },
    updateBotMessage: (state, action) => {
      const { messageId, content } = action.payload || {}
      if (!messageId) return
      state.messageTopic = state.messageTopic.map((msg) =>
        msg.messageId === messageId
          ? { ...msg, content: (msg.content || '') + content }
          : msg,
      )
    },
    changeTyping: (state, action) => {
      state.typing = { ...state.typing, ...action.payload }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getListTopic.pending, (state, action) => {
      state.isLoadingHistoryList = true
    })
    builder.addCase(getListTopic.fulfilled, (state, action) => {
      state.historyList = action.payload
      state.isLoadingHistoryList = false
    })
    builder.addCase(getListTopic.rejected, (state, action) => {
      state.isLoadingHistoryList = action.payload.loading
    })
    builder.addCase(getListTopicScroll.pending, (state, action) => {
      state.isLoadingHistoryListMore = true
    })
    builder.addCase(getListTopicScroll.fulfilled, (state, action) => {
      state.historyList = [...state.historyList, ...action.payload]
      state.isLoadingHistoryListMore = false
    })
    builder.addCase(getListTopicScroll.rejected, (state, action) => {
      state.isLoadingHistoryListMore = action.payload.loading
    })

    builder.addCase(getMessageInTopic.pending, (state, action) => {
      state.loadingMessageTopic = true
    })
    builder.addCase(getMessageInTopic.fulfilled, (state, action) => {
      state.messageTopic = action.payload.reverse()
      state.loadingMessageTopic = false
    })
    builder.addCase(getMessageInTopic.rejected, (state, action) => {
      state.loadingMessageTopic = action.payload.loading
    })

    builder.addCase(updateTopic.fulfilled, (state, action) => {
      const { topicId, topicTitle, status } = action.payload || {}
      if (!topicId) return
      if (status && status === 'InActive') {
        state.topicActive = {
          topicId: null,
          topicTitle: null,
        }
        state.historyList = state.historyList.filter(
          (t) => t.topicId !== topicId,
        )
        state.messageTopic = []
        state.statusMess = STATUS_MESS.ACTIVE
      } else {
        state.historyList = state.historyList.map((t) =>
          t.topicId === topicId ? { ...t, topicTitle } : t,
        )
        if (state.topicActive?.topicId === topicId) {
          state.topicActive = { ...state.topicActive, topicTitle }
        }
      }
    })

    builder.addCase(getQuestion.pending, (state, action) => {
      state.loadingQuestion = true
    })
    builder.addCase(getQuestion.fulfilled, (state, action) => {
      state.listQuestion = action.payload
      state.loadingQuestion = false
    })
    builder.addCase(getQuestion.rejected, (state, action) => {
      state.loadingQuestion = action.payload.loading
    })

    builder.addCase(getTopicMaxUpdatedDate.pending, (state, action) => {
      state.topicMaxUpdatedLoading = true
    })
    builder.addCase(getTopicMaxUpdatedDate.fulfilled, (state, action) => {
      state.topicMaxUpdatedDate = action.payload
      state.topicMaxUpdatedLoading = false
    })
    builder.addCase(getTopicMaxUpdatedDate.rejected, (state, action) => {
      state.topicMaxUpdatedLoading = action.payload.loading
    })
  },
})

export const loadingHistoryList = (state) =>
  state[slice.name].isLoadingHistoryList
export const showHistoryList = (state) => state[slice.name].isShowHistoryList
export const selectHistoryList = (state) => state[slice.name].historyList
export const selectTopicActive = (state) => state[slice.name].topicActive
export const selectStatusMess = (state) => state[slice.name].statusMess
export const selectMessageTopic = (state) => state[slice.name].messageTopic
export const selectLoadingQuestion = (state) =>
  state[slice.name].loadingQuestion
export const selectListQuestion = (state) => state[slice.name].listQuestion
export const selectTyping = (state) => state[slice.name].typing
export const selectTopicMaxUpdatedDate = (state) =>
  state[slice.name].topicMaxUpdatedDate

export const {
  changeShowHistoryList,
  changeTopicActive,
  changStatusMess,
  addMessageInTopic,
  createNewTopic,
  updateBotMessage,
  changeTyping,
} = slice.actions

register(slice.name, slice.reducer)
